import { useTranslation } from "react-i18next";
import LabTestsTable from "./LabTestsTable";
import React, {useContext} from "react";
import InitContext from "../pages/InitContext";

const LabTests = () => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  return (
    <div className="w3-display-container content-container">
      <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
        <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
      </div>
      <div className="w3-display-middle form-display">
        <div className="w3-panel w3-card-4 record-panel">
          <LabTestsTable>
            <h2>{t("laboratory_test_data")}</h2>
          </LabTestsTable>
        </div>
      </div>
    </div>
  );
};

export default LabTests;
